<template>
  <div id="app">
	  	<router-view></router-view>
  </div>
</template>

<style lang="scss">
#app {
	// background-color: rgb(244, 244, 244);
	box-sizing: border-box;
}
</style>
<script>
	export default {
		name: "App",
		data() {
			return {
			};
		},
		components:{

		}
	};
</script>
